import {Component, OnInit, OnDestroy} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {DateAdapter, MdSnackBar, NativeDateAdapter, Sort} from '@angular/material';

import {AppComponent} from './app.component';
import {SortTable} from './sort-table.component';

import {AuthentificationService} from './authentification.service';
import {ProductsArticleService} from './products-article.service';
import {TransactionsService} from './transactions.service';
import {StocksService} from './stocks.service';
import {ReleaseOrderService} from './release-order.service';
import {StockArticleService} from './stock-article.service';

import {EntityService} from './entity.service';

@Component({
    selector: 'app-release-order',
    templateUrl: './templates/release-order.component.html',
    styleUrls: ['./styles/release-order.component.css'],
    providers: [ProductsArticleService, StocksService, AuthentificationService, TransactionsService, SortTable, ReleaseOrderService, EntityService]
})

export class ReleaseOrderComponent implements OnInit, OnDestroy {

    private motif: any;
    private sub: any;

    component: string = "CLIENT";


    session_mode: string = "RECEPTION";

    transaction_name: string = "";
    transaction_date: Date;
    transaction_reference: string = "";
    transaction_date_delivery: Date;
    transaction_destination: string = "";
    transaction_motif: string = "";
    transaction_antecedent: any;

    prod_list: Array<any>;
    pannier_list: any;

    validate_bt: boolean = true;

    remark: string = "";
    quantity: any = 1;
    form_not_valid: boolean = false;
    sortedData: any = [];

    motif_array: Array<any> = [
        {value: "transfer", show: "Transfert"},
        {value: "reservation", show: "Réservation"},
        {value: "loss-breakage-lapsing", show: "Perte - casse - péremption"},
        {value: "show", show: "Expo - salon - démo"}
    ];

    warehouses_list: Array<any>;
    clients_list: Array<any>;
    articles_list: Array<any> = [];

    constructor(
        private route: ActivatedRoute,
        private app_component: AppComponent,
        private router: Router,
        private authentification_service: AuthentificationService,
        private transactions_service: TransactionsService,
        public snackBar: MdSnackBar,
        dateAdapter: DateAdapter<NativeDateAdapter>,
        private datepipe: DatePipe,
        private release_order_service: ReleaseOrderService,
        private activated_route: ActivatedRoute,
        private stock_article_service: StockArticleService,
        private entity_service: EntityService,
    ) {
        this.CheckUserSession();
        dateAdapter.setLocale('fr-FR');
        this.app_component.valTest = '/release-order/transfer';
        this.app_component.GetParent();
    }

    ngOnInit() {
        this.ResetOnInit();
        this.sub = this.route.params.subscribe(params => {
            this.motif = params['motif'];

            if (this.motif === "reservation") {
                this.GetClientsList();
            } else {
                this.transaction_destination = "";
            }

            this.transaction_motif = this.GetMotif();
            this.GetCurrentReferenceReleaseOrder();
        });

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    articleToSend(event: any) {
        this.AddtoPannier(event);
    }

    onDateChanged(event) {
        var date = (this.datepipe.transform(event, 'dd-MM-yyyy'));
    }

    GetMotif() {
        for (var i = 0; i < this.motif_array.length; i++) {
            if (this.motif === this.motif_array[i]['value']) {
                return this.motif_array[i]['show'];
            }
        }
    }

    GetClientsList() {
        //        clients_list
        this.entity_service.GetAllEntities(this.component).then(response => {
            this.clients_list = response['entities'];
            this.transaction_destination = this.clients_list[0]['id_entity'];
        });
    }

    GetCurrentReferenceReleaseOrder(): void {
        this.release_order_service.GetCurrentReferenceReleaseOrder(this.motif)
            .then(response => {
                this.transaction_reference = response['reference'];
            });
    }

    onDateDeliveryChanged(event) {
        var date = (this.datepipe.transform(event, 'dd-MM-yyyy'));
    }

    AddtoPannier(prod: any): void {
        //console.log(prod);
        //        if (prod.stocks > 0) {
        if (prod.available_stock > 0) {
            this.transactions_service.AddtoPannierOutofWare(prod)
                .then(pannier_list => {
                    this.pannier_list = pannier_list['list'];
                    if (pannier_list['list'].length !== 0) {
                        this.validate_bt = false;
                    }
                    if (pannier_list['message'] !== 'none') {
                        this.snackBar.open("Erreur : ", pannier_list['message'], {
                            duration: 2500
                        });
                    }
                });
        } else {
            this.SnackBar("Erreur", "Cet article est en rupture de stock.");
        }
    }

    LoadSessionOutOfWare() {
        this.transactions_service.LoadSessionOutOfWare().then(session_list => {this.pannier_list = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false} });
    }

    RemoveFromPannier(prod: any): void {
        this.transactions_service.RemoveFromPannierOutOfWare(prod.id_article).then(pannier_list => {this.pannier_list = pannier_list['list']; if (pannier_list['list'].length === 0) {this.validate_bt = true} });
    }

    EditArticleSession(prod: any): void {
        this.transactions_service.EditArticleSessionOutOfWare(prod.id_article).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    EditAndValidateModification(prod: any): void {
        if (prod.status === "RECEPTION") {
            this.EditArticleSession(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPurchase(prod);
        }
    }

    ValidateEditArticleSessionPurchase(prod: any): void {
        if (isNaN(prod.quantity)) {
            prod.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionOutOfWare()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionOutOfWare(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
        }
    }

    ValidatePannier(): void {
        if (this.transaction_name !== "") {
//            var date_1 = (this.datepipe.transform(this.transaction_date, 'yyyy-MM-dd h:mm:ss'));
//            var date_2 = (this.datepipe.transform(this.transaction_date_delivery, 'yyyy-MM-dd h:mm:ss'));
            var date_1 = (this.datepipe.transform(this.transaction_date, 'medium'));
            var date_2 = (this.datepipe.transform(this.transaction_date_delivery, 'medium'));
            this.release_order_service.ValidateReleaseOrder(this.transaction_name, date_1, this.transaction_reference, date_2, this.transaction_destination, this.motif, this.remark, this.transaction_antecedent)
                .then(result => {
                    this.pannier_list = result['list'];
                    this.validate_bt = true;
                    this.transaction_name = "";
                    this.transaction_destination = "";
                    this.transaction_date = new Date();
                    this.transaction_date_delivery = new Date();
                    this.remark = "";
                    this.transaction_reference = result['new_reference'];
                    this.SnackBar(result['title'], result['message']);

                    this.stock_article_service.getArticles(undefined)
                        .then(response => {
                            this.articles_list = response;
                            /*setInterval(() => {           // the following is required, otherwise the view will not be updated
                                this.ref.markForCheck();
                            }, 1000);*/

                        });
                });
        } else {
            this.form_not_valid = true;
            setTimeout(() => {this.form_not_valid = false;}, 4000);

            console.log(this.transaction_name);
            console.log(this.form_not_valid);
        }
    }

    CheckUserSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification'])
                }
            });
    }

    ResetAll(): void {
        this.release_order_service.ResetPannier().then(response => {
            if (response['state'] === 'OK') {
                this.pannier_list = response['list'];
                this.transaction_name = "";
                this.transaction_destination = "";
                this.transaction_date = new Date();
                this.transaction_date_delivery = new Date();
                this.remark = "";
            }
            this.SnackBar(response['title'], response['message']);
        });
    }

    ResetOnInit(): void {
        this.release_order_service.ResetPannier().then(response => {
            if (response['state'] === 'OK') {
                this.pannier_list = response['list'];
                this.transaction_name = "";
                this.transaction_destination = "";
                this.transaction_date = new Date();
                this.transaction_date_delivery = new Date();
                this.remark = "";
            }
        });
    }

    GetTransactionDetails_cb(purchase_list: any): void {
        this.activated_route.params.subscribe((params: Params) => {
            let id = params['id_transaction_details'];
            if (id !== undefined) {

                this.app_component.valTest = '/release-order/transfer';
                this.app_component.GetParent();
                //                this.AddtoCart(this.sortedDataNotValidate[index]);
            }
        });
    }

    SnackBar(title: any, message: any) {
        this.snackBar.open(title, message, {
            duration: 2500
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/release-order.component.ts